module.exports = __webpack_public_path__ + "img/group27022.6f24d063.svg";